import { Helmet } from 'react-helmet-async'

/**
 * Preconnect hints for Vimeo video delivery.
 * These establish early connections to Vimeo's CDN servers,
 * reducing video load time by eliminating connection setup latency.
 *
 * Domains:
 * - player.vimeo.com: Vimeo player iframe and scripts
 * - vod-progressive.akamaized.net: Progressive video delivery CDN
 * - f.vimeocdn.com: Vimeo static assets (thumbnails, scripts)
 * - i.vimeocdn.com: Vimeo image CDN
 */
function WrappedPreconnectHints() {
  return (
    <Helmet>
      <link rel="preconnect" href="https://player.vimeo.com" />
      <link rel="preconnect" href="https://vod-progressive.akamaized.net" />
      <link rel="preconnect" href="https://f.vimeocdn.com" />
      <link rel="preconnect" href="https://i.vimeocdn.com" />
      <link rel="dns-prefetch" href="https://player.vimeo.com" />
      <link rel="dns-prefetch" href="https://vod-progressive.akamaized.net" />
    </Helmet>
  )
}

export default WrappedPreconnectHints
